import script from "./bgMusicStting.vue?vue&type=script&setup=true&lang=js"
export * from "./bgMusicStting.vue?vue&type=script&setup=true&lang=js"

import "./bgMusicStting.vue?vue&type=style&index=0&id=1faf783f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1faf783f"]])

export default __exports__